import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";

const initialState = {
  onboardingData: null,
  status: "idle",
  error: null,
  selectedservices: [],
  onbordeddata: {},
};

export const postOnboarding = createAsyncThunk(
  "onboarding/postOnboarding",
  async (data) => {
    return await apiService(API_ROUTES.ONBOARDING, "POST", { body: data });
  },
);

export const fetchOrganizations = createAsyncThunk(
  "onboarding/fetchorganization",
  async () => {
    const { data } = await apiService(API_ROUTES.ORGANIZATIONS);

    return data;
  },
);

const entityOnboardSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    resetOnboarding: (state) => {
      state.status = "idle";
      state.onboardingData = null;
    },
    setSuccessOnboarding: (state, action) => {
      state.status = "idle";
      state.onbordeddata = action.payload;
    },
    setSelectedService: (state, action) => {
      state.selectedservices = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postOnboarding.pending, (state) => {
        state.status = "loading";
      })
      .addCase(postOnboarding.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.onboardingData = action.payload;
      })
      .addCase(postOnboarding.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchOrganizations.pending, (state) => {
        state.status = "loading";
        state.isOrgLoading = true;
      })
      .addCase(fetchOrganizations.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.organizations = action.payload;
        state.isOrgLoading = false;
      })
      .addCase(fetchOrganizations.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.isOrgLoading = false;
      });
  },
});

export const { resetOnboarding, setSelectedService, setSuccessOnboarding } =
  entityOnboardSlice.actions;
export default entityOnboardSlice.reducer;
